import type { CollisionDetection } from "@dnd-kit/core";
import { closestCenter, pointerWithin, rectIntersection } from "@dnd-kit/core";

export const customCollisionDetection: CollisionDetection = args => {
  const { active, droppableContainers } = args;

  const isDraggingFromLibrary = active.data.current?.type === "library_item";

  if (isDraggingFromLibrary) {
    const pointerCollisions = pointerWithin(args);
    const containerCollisions = pointerCollisions.filter(collision => {
      const container = droppableContainers.find(c => c.id === collision.id);
      const droppableType = container?.data.current?.droppableType;
      return droppableType === "exercises" || droppableType === "lessons" || droppableType === "week";
    });

    if (containerCollisions.length > 0) {
      return containerCollisions;
    }

    const intersectionCollisions = rectIntersection(args);
    const containerIntersections = intersectionCollisions.filter(collision => {
      const container = droppableContainers.find(c => c.id === collision.id);
      const droppableType = container?.data.current?.droppableType;
      return droppableType === "exercises" || droppableType === "lessons" || droppableType === "week";
    });

    if (containerIntersections.length > 0) {
      return containerIntersections;
    }

    return [];
  }

  return closestCenter(args);
};
